import { get } from '@core/request';

export const fetchConferenceProjectSimpleList = () => get('/conference/boss/conferences/simplelist');

export const fetchSelectionProjectSimpleList = () => get('/selection/admin/projects/simplelist');

export const fetchInvitationGroupSimpleList = () => get('/invitation/boss/invitationgroups/simplelist');

export const fetchSurveySimpleList = () => get('/survey/surveys/simplelist');
